import React, { useContext, useState, useEffect } from 'react';
import { TemplateContext } from '../../layout';
import PropTypes from 'prop-types';
import CardHalfEach from './cardHalfEach';
import CardHalfBundle from './cardHalfBundle';
import CardFullBundle from './cardFullBundle';
import CardFullEach from './cardFullEach';

const ProductCard = ({ data, cardType, layoutOption }) => {
	const productsConfig = window.post_template.checkout_v3_products;
	const [isActive, setIsActive] = useState(false);
	const [templateContext, setTemplateContext] = useContext(TemplateContext);
	const [modifyFont, setModifyFont] = useState(false);
	const outOfStock = templateContext?.outOfStockMode;

	useEffect(() => {
		data?.amount == templateContext?.config?.product?.amount ? setIsActive(true) : setIsActive(false);
	}, [templateContext]);

	const handleCardClick = () => {
		setTemplateContext({ ...templateContext, config: { ...templateContext.config, product: data } });
	};

	// toggle 1x4 layout for badges

	const showBadges = productsConfig.checkout_v3_products_displayBadges;
	const totalPricePosition = productsConfig.checkout_v3_products_oldPriceRow;
	const totalPriceShow = productsConfig.checkout_v3_products_displayTotal;

	// toggle 2x2 layout badges mobile

	const mobileToggleBadges = productsConfig.checkout_v3_products_displatMobileBadges;

	// Inline product Card Styles

	const cardStyle = isActive
		? {
				boxShadow: outOfStock
					? `0px 0px 0px 3px# #ff0033`
					: `0px 0px 0px 3px ${productsConfig.checkout_v3_products_selectBackground}`,
				backgroundColor: productsConfig.checkout_v3_products_selectedCardBackground,
			}
		: {
				boxShadow: outOfStock
					? `0px 0px 0px 1px #ff0033`
					: `0px 0px 0px 1px ${productsConfig.checkout_v3_products_notSelectBackground}`,
				backgroundColor: productsConfig.checkout_v3_products_CardBackground,
			};

	const cardHeadingStyle = isActive
		? {
				backgroundColor: outOfStock ? '#ff0033' : productsConfig.checkout_v3_products_selectBackground,
				color: productsConfig.checkout_v3_products_selectText,
				transform: 'scale(1.01)',
				borderTopLeftRadius: '4px',
				borderTopRightRadius: '4px',
				transition: 'transform 150ms ease-in',
			}
		: {
				backgroundColor: outOfStock
					? 'rgba(255, 0, 51, 0.3)'
					: productsConfig.checkout_v3_products_notSelectBackground,
				color: productsConfig.checkout_v3_products_notSelectText,
				transform: 'scale(1.0001)',
				borderTopLeftRadius: '4px',
				transition: 'transform 150ms ease-in',
				borderTopRightRadius: '4px',
			};

	const savingsBadgeStyle = isActive
		? {
				backgroundColor: productsConfig.checkout_v3_products_selectedSavingsBackground,
				color: productsConfig.checkout_v3_products_selectedShippingText,
			}
		: {
				backgroundColor: productsConfig.checkout_v3_products_notSelectedBadgeBackground,
				color: productsConfig.checkout_v3_products_notSelectedBadge,
			};

	const shippingBadgeStyle = isActive
		? {
				backgroundColor: productsConfig.checkout_v3_products_selectedShippingBackground,
				color: productsConfig.checkout_v3_products_selectedShippingText,
			}
		: {
				backgroundColor: productsConfig.checkout_v3_products_notSelectedBadgeBackground,
				color: productsConfig.checkout_v3_products_notSelectedBadge,
			};

	// old price positioning

	const oldPriceStyle = totalPricePosition
		? {
				flexDirection: 'column-reverse',
			}
		: {
				flexDirection: 'row',
			};

	const totalSpan = totalPricePosition
		? {
				marginBottom: '4px',
				marginLeft: '0px',
			}
		: {
				marginBottom: '0px',
				marginLeft: '4px',
			};

	const primaryColor = { color: productsConfig.checkout_v3_products_productNameColor };
	const secondaryColor = { color: productsConfig.checkout_v3_products_eachColor };
	const priceColor = { color: productsConfig.checkout_v3_products_priceColor };
	const totalColor = { color: productsConfig.checkout_v3_products_totalColor };

	const stylesObject = {
		card: cardStyle,
		heading: cardHeadingStyle,
		savingsBadge: savingsBadgeStyle,
		shippingBadge: shippingBadgeStyle,
		primaryColor: primaryColor,
		secondaryColor: secondaryColor,
		priceColor: priceColor,
		totalColor: totalColor,
	};

	const labelsObject = {
		saveLabel: productsConfig?.tr_checkout_v3_products_saveLabel,
		totalLabel: productsConfig?.tr_checkout_v3_products_totalLabel,
		eachLabel: productsConfig?.tr_checkout_v3_products_eachLabel,
		shipping: data.tr_shipping_label ? data.tr_shipping_label : productsConfig.tr_checkout_v3_products_shippingLabel,
	};

	const eachOptions = {
		oldPricePosition: oldPriceStyle,
		totalPosition: totalSpan,
	};

	return layoutOption == 'full' ? (
		cardType == 'each' ? (
			<CardFullEach
				handleCardClick={handleCardClick}
				styles={stylesObject}
				labels={labelsObject}
				data={data}
				displayBadges={showBadges}
				priceLayout={eachOptions}
				showTotal={totalPriceShow}
				outOfStock={outOfStock}
			/>
		) : (
			<CardFullBundle
				handleCardClick={handleCardClick}
				styles={stylesObject}
				labels={labelsObject}
				data={data}
				displayBadges={showBadges}
				outOfStock={outOfStock}
			/>
		)
	) : cardType == 'each' ? (
		<CardHalfEach
			handleCardClick={handleCardClick}
			styles={stylesObject}
			labels={labelsObject}
			data={data}
			displayBadges={mobileToggleBadges}
			priceLayout={eachOptions}
			showTotal={totalPriceShow}
			outOfStock={outOfStock}
			modifyFont={modifyFont}
			setModifyFont={setModifyFont}
		/>
	) : (
		<CardHalfBundle
			handleCardClick={handleCardClick}
			styles={stylesObject}
			labels={labelsObject}
			data={data}
			displayBadges={mobileToggleBadges}
			outOfStock={outOfStock}
		/>
	);
};

ProductCard.propTypes = {
	cardType: PropTypes.oneOf(['each', 'pack']).isRequired,
	layoutOption: PropTypes.oneOf(['half', 'full']).isRequired,
};

export default ProductCard;
